import { useCallback } from 'react'

import { CopysmithPromptsType } from '~generated/types'
import {
  copilotCopyWithAIModalHandler,
  copilotCopyWithAIModalStateVar,
} from '~modules/launches/containers/CopilotCopyWithAIModal/utils'

type Options = {
  gptPrompt?: CopysmithPromptsType
  heading?: string
  description?: string
}

function useGenerateCopyWithAIModal(cb: (text: string) => void, options?: Options) {
  const generateWithAI = useCallback(() => {
    copilotCopyWithAIModalStateVar({
      heading: options?.heading || 'Generate copy with AI',
      description:
        options?.description ||
        'Enter a few lines describing your product and its value (your “elevator pitch”). We’ll use this to generate your copy.',
      gptPrompt: options?.gptPrompt,
      onCompleted: (AIContent) => {
        cb(AIContent)
        copilotCopyWithAIModalHandler.close()
      },
    })

    copilotCopyWithAIModalHandler.open()
  }, [cb, options?.description, options?.gptPrompt, options?.heading])

  return { generateWithAI }
}

export default useGenerateCopyWithAIModal
